import { createUseStyles } from 'react-jss';
import { backgrounds, gradients } from '../../utils/theme';

export default createUseStyles({
  loginModal: {
    '& .ant-modal-content': {
      height: '710px',
      '& .ant-modal-header': {
        border: 'none !important',
        padding: '0px !important',
      },
    },
    '& .ant-modal-body': {
      height: '100%',
      padding: '0px !important',
    },
    '@media (max-width: 767px)': {
      minWidth: '100vw !important',
      top: '0 !important',
      left: '0 !important',
      margin: 0,
      padding: 0,
      '& .ant-modal-content': {
        padding: '16px !important',
        boxSizing: 'border-box',
        height: '100vh !important',
        width: '100vw',
        background: gradients.gradient1,
        borderRadius: 'unset',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        '&::before': {
          content: '""',
          background: '#fff',
          position: 'absolute',
          width: '100vw',
          height: '100vh',
          zIndex: -1,
        },
        '& .ant-modal-close': {
          display: 'none',
        },
        '& .ant-modal-body': {
          background: backgrounds.bg4,
          border: `1px solid ${backgrounds.bg2}`,
          borderRadius: '8px',
          padding: '16px !important',
          width: '100%',
          height: 'auto',
        },
        '& .ant-modal-header, & .ant-modal-footer': {
          flex: 1,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          background: 'none',
          margin: 0,
          '& >.ant-modal-title': {
            height: '100%',
            width: '100%',
            padding: '0 !important',
          },
        },
      },
    },
  },
});
